import { CircularProgress } from '@mui/material';
import _ from 'lodash';
import { TitledPage } from '@client/new/components/Misc';
import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import auth from '@client/components/auth';
import { Typography } from '@design-system/components/typography/typography';
import { EnableDirectMessage } from './EnableDirectMessage';
import { InboxViewModel, useInboxViewModel } from './useInbox.viewModel';
import { InboxChat } from './InboxChat';

type InboxPageProps = {
  params: {
    influencerId: string;
  };
};

export const InboxPage = (props: InboxPageProps) => {
  const influencerId = props.params.influencerId
    ? parseInt(props.params.influencerId)
    : auth.getUser().influencerId;
  const viewModel = useInboxViewModel({ influencerId });

  return (
    <AsyncRenderer
      data={viewModel}
      loadRender={
        <TitledPage title="Direct Messages">
          <div className="flex justify-center items-center">
            <CircularProgress />
          </div>
        </TitledPage>
      }
      renderer={(data) => (
        <TitledPage title="Direct Messages">
          <Inbox {...data} />
        </TitledPage>
      )}
    />
  );
};

const Inbox = (p: InboxViewModel) => {
  if (p.hideDirectMessages)
    return (
      <div className="w-full h-full flex flex-col items-center justify-center">
        <Typography>Feature available only with subscription</Typography>
      </div>
    );

  if (!p.isMessagingEnabled) {
    return <EnableDirectMessage {...p} />;
  }

  return <InboxChat {...p} />;
};
